import { DataManager } from "./DataManager";
import { Moji } from '../moji/Moji';

export interface Point3 {
    x:number,
    y:number,
    z:number
}

export interface ITimeline{
    start():void
}

export class Params {

    //static CONNECT_LINE:string="CONNECT_LINE";
    //static CONNECT_LINE_SPLIT:string="CONNECT_LINE_SPLIT";
    static LINE_OFFSET_X:number = -10;
    static LOGO_WIDTH:number = 1850;

    static DOT_SPEED_LOW:number = 0.001
    static DOT_SPEED_HIGH:number = 0.002;
    static dot_speed:number = 0.001;

    static LINE_MODE_NONE:number=0;
    static LINE_MODE_SINGLE:number=1;
    static LINE_MODE_MULTI:number=2;
    static LINE_MODE_LOGO:number=3;
    static LINE_MODES:number[] = [0,1,2];
    static line_mode = 1;

    static MOJI_Q:string="q";
    static MOJI_U:string="u";
    static MOJI_A:string="a";
    static MOJI_A2:string="a2";
    static MOJI_N:string="n";
    static MOJI_T:string="t";
    static MOJI_I:string="i";
    static MOJI_M:string="m";
    static MOJI_LOGO1:string="logo1";
    static MOJI_LOGO2:string="logo2";
    
    
    static Z_MARK_STROKES:number=200;
    static Z_MARK_MESH:number=100;
    static Z_DOTS:number = 160;
    static Z_STROKES:number = 150;
    static Z_LOGO_TYPE:number=-400;
    /*
     MojiPointsUtil.makePoints("q",textQ);
        MojiPointsUtil.makePoints("u",textU);
        MojiPointsUtil.makePoints("a",textA);
        MojiPointsUtil.makePoints("a2",textA2);
        
        MojiPointsUtil.makePoints("n",textN);
        MojiPointsUtil.makePoints("t",textT);
        MojiPointsUtil.makePoints("i",textI);
        MojiPointsUtil.makePoints("m",textM);

        MojiPointsUtil.makePoints("logo1",logo1);
        MojiPointsUtil.makePoints("logo2",logo2);

    */


}

//export {Params};